// extracted by mini-css-extract-plugin
export var about = "about-module--about--Um+LS";
export var intro = "about-module--intro--kmxBQ";
export var pageContent = "about-module--page-content--FnN2F";
export var sectionSpacingB = "about-module--section-spacing-b--P56yv";
export var sectionSpacingT = "about-module--section-spacing-t--cUhuF";